<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left>
        <a class="link color-theme-white popup-close" href="#">
          <i class="icon icon-back"></i>
          <span>返回</span>
        </a>
      </f7-nav-left>
      <f7-nav-title>邀请您加入</f7-nav-title>
    </f7-navbar>
    <div>
      <f7-card>
        <f7-card-header>
          <div v-if="notice.headImage">
            <img :src="`${imageUrl}?attachmentId=${notice.headImage}`" height="40" width="40"/>
          </div>
          <div v-else>
            <img src="@/assets/img/avatar.png" height="40" width="40"/>
          </div>
          <div style="padding-left: 1rem;">{{ notice.inviteUserName }}</div>
          <div style="padding-left: 0.5rem; flex: auto;">邀请您加入</div>
        </f7-card-header>
        <f7-card-content>
          <div class="content-text">
            {{ notice.companyName }}
          </div>
          <div class="sub-text">
            已启用鲁班工匠，请尽快加入我们吧！
          </div>
        </f7-card-content>
      </f7-card>
      <f7-block
        style="padding-top: 1rem; text-align: center;"
        v-if="notice.result ==='0' || notice.result ==='1'">
        您已经
        <span class="tip-text">
        {{ notice.result ==='0' ? '拒绝' : '接受' }}
        </span>
        此邀请，不能再操作啦！
      </f7-block>
      <f7-block style="padding-top: 1rem;" v-else>
        <f7-row>
          <f7-col width="50">
            <f7-button @click="cancel">拒绝</f7-button>
          </f7-col>
          <f7-col width="50">
            <f7-button fill @click="join">加入</f7-button>
          </f7-col>
        </f7-row>
      </f7-block>
    </div>
  </f7-page>
</template>
<script>
import { dateFormat } from '@/util/dateUtils';
import { createToast } from '@/util/compUtils';
import { handleNotice } from '@/api/notice';
import { imageView } from '@/api/common';

export default {
  props: ['notice', 'opened'],
  data() {
    return {
      imageUrl: imageView,
    };
  },
  filters: {
    formatDateValue: value => dateFormat(value),
  },
  methods: {
    cancel() {
      const params = { id: this.notice.id, operate: 'reject' };
      this.$f7.dialog.confirm('确认要拒绝邀请吗？', () => {
        handleNotice(params).then((result) => {
          if (result.code === 0) {
            createToast(this, '完成拒绝邀请');
            this.$emit('update:opened', false);
          }
        });
      });
    },
    join() {
      const params = { id: this.notice.id, operate: 'agree' };
      handleNotice(params).then((result) => {
        if (result.code === 0) {
          createToast(this, '成功加入队伍');
          this.$emit('update:opened', false);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .content-text {
    padding: 3rem 0rem;
    font-size: 1.3rem;
    text-align: center;
    color: $font-color;
  }
  .sub-text {
    font-size: 0.8rem;
    text-align: center;
    color: $second-font-color;
  }

  .tip-text {
    color: $second-color;
  }

</style>



// WEBPACK FOOTER //
// src/pages/notice/info.vue